import React from "react";
import { useHistory } from "react-router-dom";
import { useTracking } from "react-tracking";

import { UserCycleStatus } from "models/user";
import Button from "../Button";

interface ActionButtonProps {
  id: string;
  status: UserCycleStatus;
}

const getLabel = (status: UserCycleStatus): string => {
  switch (status) {
    case UserCycleStatus.assessmentsNull: {
      return "N/A";
    }
    case UserCycleStatus.assessmentsNotStarted: {
      return "N/A";
    }

    case UserCycleStatus.assessmentsInProgress: {
      return "View Details";
    }

    case UserCycleStatus.readyToScore: {
      return "Score";
    }

    case UserCycleStatus.readyForReview: {
      return "Review";
    }
    case UserCycleStatus.scoringInProgress:
    case UserCycleStatus.scoreFinalized: {
      return "View";
    }
  }
};

const ActionButton: React.FC<ActionButtonProps> = ({ status, id }: ActionButtonProps) => {
  const history = useHistory();
  const tracking = useTracking();

  return (
    <Button
      secondary
      longText
      compressed
      style={{
        minWidth: "100px",
        width: "100%",
        maxWidth: "170px"
      }}
      onClick={() => {
        const url = "/user-assessments/" + id;

        tracking.trackEvent({
          url,
          actions: ["Assessments", "Score Assessments", id]
        });

        history.push(url);
      }}
      disabled={
        status === UserCycleStatus.assessmentsNotStarted ||
        status === UserCycleStatus.assessmentsNull
      }
    >
      {getLabel(status)}
    </Button>
  );
};

export default ActionButton;
